export default "__VITE_ASSET__DZn2OOuN__"